export const localStorageHelper = {
  setItem: (key: string, value: string) => localStorage.setItem(key, value),
  removeItem: (key: string) => localStorage.removeItem(key),
  getItem: (key: string) => localStorage.getItem(key)
}

export const clearLocalStorageExcept = (keysToKeep?: string[]) => {
  if (!Array.isArray(keysToKeep) || keysToKeep.length === 0) {
    // Usuń wszystko
    localStorage.clear()
    return
  }

  // Pobierz wszystkie klucze z localStorage
  const allKeys = Object.keys(localStorage)
  for (const key of allKeys) {
    const shouldKeep = keysToKeep.some((keepKey) => key.includes(keepKey))
    if (!shouldKeep) {
      localStorage.removeItem(key)
    }
  }
}
